/**
 * Which way traffic flows for a phone number capability. primary owns this vocabulary — a
 * capability row pairs a direction with a channel to describe one thing the number can do.
 */
export var PhoneNumberCapabilityDirection;
(function (PhoneNumberCapabilityDirection) {
    PhoneNumberCapabilityDirection["Inbound"] = "Inbound";
    PhoneNumberCapabilityDirection["Outbound"] = "Outbound";
})(PhoneNumberCapabilityDirection || (PhoneNumberCapabilityDirection = {}));
//# sourceMappingURL=direction.js.map